'use strict'

import {bootstrap} from '../bootstrap/bootstrap'
import {setupDirtyInput, setupPhoneInputValidation} from './validation'
import {submitContactForm} from './contactForm'
import {submitMailingListForm} from './mailingList'

const contactForms = Array.from(document.getElementsByClassName('form--contact-us'))
const inputs = contactForms.reduce((acc, form) => {
  return acc.concat(Array.from(form.getElementsByTagName('input')))
}, [])
const phoneInputs = contactForms.reduce((acc, form) => {
  return acc.concat(Array.from(form.querySelectorAll('input[type="tel"]')))
}, [])
const mailingListForm = Array.from(document.getElementsByClassName('form--subscribe'))

bootstrap(inputs, setupDirtyInput)
bootstrap(phoneInputs, setupPhoneInputValidation)
bootstrap(contactForms, form => form.addEventListener('submit', submitContactForm))
bootstrap(mailingListForm, mailingListForm => mailingListForm.addEventListener('submit', submitMailingListForm))
